export interface PhoneServiceDetail {
  id: number;
  customerId: string;
  contractId: string;
  userAccountId: number;
  language: number;
  brandId: number;
  greeting: string;
  admitOutsourcing: boolean;
  subAccountInfo: string;
  callnoteSubject: string;
  callnoteForwardingType: string;
  callerNumberVisible: boolean;
  showAllEmailRecipients: boolean;
  countryPrefix: string;
  timezone: string;
  outgoingPhoneNumber: string | null;
  blockClip: boolean;
  smsSenderName: string;
  multipartSms: boolean;
  faxHandling: string;
  blindTransfer: string;
  voiceBotMode: string | null;
  transcriptionAllowed: boolean;
  /** null = inherit the brand default (MANDANT.MDT_DEFAULT_HOLIDAY_AS_SUNDAY), true/false = override it. */
  holidayAsSunday: boolean | null;
  waitingQueuePriority: number | null;
  waitingQueueRingTime: number;
  /** Seconds the caller waits IN the queue before being forwarded. null = redirector default (60 s). */
  waitingQueueTimeout: number | null;
  /** Target of that forward. null/empty switches the queue-timeout forward off. */
  waitingQueueTimeoutForwardTo: string | null;
  callRecordingAllowed: boolean;
  callGroup: CallGroup | null;
  outboundOutgoingNumber: string | null;
  outboundGreeting: string | null;
  description: string;
  type: string;
  linkToCai: string;
  faxForwardingNumber: string | null;
  currentInfo: string | null;
  importantInfo: string | null;
  defaultCallHandling: { excuse: string; forwardingInstruction: string; info: string | null } | null;
}

/** `GET /cli-verification/number/signalled` (PS-6391): verification state of `outboundOutgoingNumber`. */
export interface CliSignalledNumber {
  phoneNumber: string | null;
  /** NONE | PENDING | VERIFIED; null when there is no number. A locked number reads PENDING. */
  verificationStatus: string | null;
  /** VOICEBOT | GRANDFATHERED; null unless verified. */
  verificationMethod: string | null;
  sipTrunkBooked: boolean;
}

export const CLI_VERIFICATION_STATUS = { NONE: 'NONE', PENDING: 'PENDING', VERIFIED: 'VERIFIED' } as const;
export const CLI_VERIFICATION_METHOD = { VOICEBOT: 'VOICEBOT', GRANDFATHERED: 'GRANDFATHERED' } as const;

export interface Language {
  id: number;
  name: string;
  abbreviation: string;
  active: boolean;
  skill: string;
}

export interface CallGroup {
  id: number;
  name: string;
}

export interface Skill {
  skill: { name: string; prerequisites: any[]; blockers: any[] };
  nice: boolean;
  startTime: string;
  endTime: string;
  weekdays: string;
}
